/**
 * Pledges variant gallery filter.
 * Each slideshow-slide has data-pledges-color set server-side in Liquid.
 * This script shows only slides whose color matches the selected Color option.
 */
(function () {
  var ALIAS = {
    'baby_blue': 'baby blue', 'baby-blue': 'baby blue',
    'baby_pink': 'baby pink', 'baby-pink': 'baby pink',
    'light_grey': 'light grey', 'light-grey': 'light grey', 'lightgrey': 'light grey',
    'light_gray': 'light grey', 'light-gray': 'light grey', 'lightgray': 'light grey',
  };

  function normalise(raw) {
    var v = (raw || '').toLowerCase().trim();
    return ALIAS[v] || v;
  }

  function filterGallery(selectedRaw) {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var selected = normalise(selectedRaw);
    if (!selected) return;

    var slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
    if (!slides.length) return;

    // Only filter if at least one slide has a non-empty data-pledges-color attribute
    var anyTagged = slides.some(function (s) {
      var c = s.getAttribute('data-pledges-color');
      return c !== null && c !== '';
    });

    if (!anyTagged) return; // images not named by color yet — show all

    var matchCount = 0;
    slides.forEach(function (slide) {
      var attr = slide.getAttribute('data-pledges-color');
      var fileColor = normalise(attr || '');

      if (!fileColor) {
        // Untagged image (e.g. size guide) — always visible
        slide.style.display = '';
        return;
      }

      var matches = selected.indexOf(fileColor) !== -1 || fileColor.indexOf(selected) !== -1;
      slide.style.display = matches ? '' : 'none';
      if (matches) matchCount++;
    });

    // Safety: if nothing matched show all
    if (matchCount === 0) {
      slides.forEach(function (s) { s.style.display = ''; });
    }
  }

  function getSelectedColor() {
    // Check checked radio buttons in variant picker
    var radios = document.querySelectorAll('variant-picker input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      var name = (radios[i].name || '').toLowerCase();
      if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1) {
        return radios[i].value;
      }
    }
    // Fallback: select element
    var selects = document.querySelectorAll('variant-picker select');
    for (var j = 0; j < selects.length; j++) {
      var sName = (selects[j].name || '').toLowerCase();
      if (sName.indexOf('color') !== -1 || sName.indexOf('colour') !== -1) {
        return selects[j].value;
      }
    }
    return null;
  }

  function init() {
    // Apply immediately on load
    var initial = getSelectedColor();
    if (initial) filterGallery(initial);

    // Re-apply whenever a color option changes
    document.addEventListener('change', function (e) {
      var name = (e.target.name || '').toLowerCase();
      if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1) {
        filterGallery(e.target.value);
      }
    });

    // Also catch programmatic variant updates
    document.addEventListener('variant:update', function () {
      var color = getSelectedColor();
      if (color) filterGallery(color);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
